import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import MenuItemButton from "../../2DComponents/MenuItemButton"

export default function PhoneNavBar(props) {

    return(
        <AppBar 

            position="static" 
            elevation={0}
            style={{
                backgroundColor: 'transparent',
            }}

        >
            <Toolbar className="toolbar">
               
                    <MenuItemButton> TJÄNSTER </MenuItemButton>
                    <MenuItemButton> OM OSS </MenuItemButton>
                    <Button 
                        variant="outlined"
                        style={{
                            color: `whitesmoke`,
                            borderColor: 'whitesmoke',
                            borderRadius:'15px',
                            borderWidth: '2px',
                            fontSize:'15px',
                            fontFamily:'sofia-pro',
                        }}
                            
                    >KONTAKT</Button>

            </Toolbar>
      </AppBar>
    )
}